module.exports = __webpack_public_path__ + "img/bg4.d87f9db9.jpg";